import React from 'react';

const BecomePart = ({ title, image, description, isPopular }) => (
  <div className={`h-full bg-primary-50 rounded-lg shadow-md p-6 ${isPopular ? 'border-2 border-primary-500' : ''}`}>
    <div className="h-48 overflow-hidden">
      <img
        src={image}
        alt={title}
        className="w-full h-full object-cover transform hover:scale-105 transition-transform duration-300"
      />
    </div>
    <div className="p-6 text-center">
      <h3 className="text-xl font-semibold text-primary-500 mb-3">{title}</h3>
      <p className="text-primary-text">{description}</p>
    </div>
  </div>
);

export default BecomePart;